import {createContext, useContext, useEffect, useReducer} from "react";
import {initialState, reducer, setBookingList, setBookingListLoading, setTabActive} from "./reducer";
import {useQueryContentList} from "../../../api/cmsContent";
import {setBannerList} from "../home/reducer";
import {useQryReserveInfoPageForPc} from "../../../api/shopItemReserveInfo";
import {useNavigate} from "react-router";

const Context = createContext(initialState);

function BookingListController() {
  const { dispatch } = useBookingListContext();
  
  const { getBanner } = useQueryContentList();
  const { loading, getBooking } = useQryReserveInfoPageForPc();
  const navigate = useNavigate();
  
  /**
   * 查看预约详情
   * @param item
   */
  const gotoBookingDetail = (item) => {
    navigate(`/bookingDetail?id=${item.infoId}`);
  };
  
  /**
   * 获取预约banner
   * @returns {Promise<void>}
   */
  const getBannerList = async () => {
    let { data } = await getBanner({ businessType: 3, placeCode: 75 });
    
    if (data) {
      dispatch(setBannerList(data));
    }
  };
  
  /**
   * 获取预约列表
   * @returns {Promise<void>}
   */
  const getBookingList = async () => {
    let { data } = await getBooking({ page: 1, limit: 20 });
    if (data) {
      dispatch(setBookingList(data));
    }
  };
  
  /**
   * 选择tab
   * @param active
   */
  const setTabsActive = (active) => {
    dispatch(setTabActive(active));
  };
  
  useEffect(() => {
    dispatch(setBookingListLoading(loading));
  }, [loading]);
  
  return {
    getBannerList,
    getBookingList,
    gotoBookingDetail,
    setTabsActive
  };
  
}

function useBookingListContext() {
  const { state, dispatch } = useContext(Context);
  
  return {
    state,
    dispatch,
  };
}

export {useBookingListContext, BookingListController};

export default function BookingListContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  return (
    <Context.Provider
      value={{ state, dispatch }}
      initialState={initialState}
      reducer={reducer}>
      {children}
    </Context.Provider>
  );
}
